<!-- {{htmlContents}} -->
<!-- <div [innerHTML]="htmlContents"></div> -->
<div [innerHTML]="contentSanitizedHtml(htmlContents)"></div>
<div class="showmorebtnproduct-rates__action js-showmore__action" *ngIf="isshowMoreButton">
  <button type="button" class="showmorebtnbutton js-showmore__button" (click)="onClickShowMore()">
    Show More<svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 64 32"
      enable-background="new 0 0 64 32"
      xml:space="preserve"
      role="presentation"
      focusable="false"
    >
      <path fill="currentColor" d="M0,11.9h43.8V0L64,15.5L43.8,32V20.1H0V11.9z"></path>
    </svg>
  </button>
</div>
